// @flow
import React from "react";
import { useSelector } from "react-redux";

import {
  SelecaoCasasDecimais,
  SelecaoToleranciaDiasValorMercado,
  SelecaoAjusteDias,
  SelecaoPeriodo,
  SelecaoDeflacao,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarMercado = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      ajusteDias: edicaoMedida.ajusteDias,
      toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
      deflator: edicaoMedida.deflator,
      valorBaseDeflator: edicaoMedida.valorBaseDeflator,
      valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
      dataBaseDeflator: edicaoMedida.dataBaseDeflator,
      dataBaseDeflatorDataEspecifica:
        edicaoMedida.dataBaseDeflatorDataEspecifica,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      ajusteDias: edicaoMedida.ajusteDias,
      toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
      deflator: edicaoMedida.deflator,
      valorBaseDeflator: edicaoMedida.valorBaseDeflator,
      valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
      dataBaseDeflator: edicaoMedida.dataBaseDeflator,
      dataBaseDeflatorDataEspecifica:
        edicaoMedida.dataBaseDeflatorDataEspecifica,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

export default function Mercado() {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDiasValorMercado />
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoDeflacao exibirLabelLegado={true} />
        </div>
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__box">
          <SelecaoToleranciaDiasValorMercado />
          <SelecaoAjusteDias />
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoDeflacao exibirLabelLegado={true} />
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />
      </>
    );
  }
}
